import { useAuth0 } from "@auth0/auth0-react";
import Button from "@mui/material/Button";

const LogoutButton = () => {
  const { logout, isAuthenticated } = useAuth0();
  const returnTo = window.location.origin;

  const handleLogOutClick = () => {
    localStorage.removeItem("workflow");
    logout({ returnTo });
  };
  return (
    isAuthenticated && (
      <Button className="siteBlue" onClick={handleLogOutClick}>
        Log Out
      </Button>
    )
  );
};

export default LogoutButton;
